export type TagMemoVariant = 'tag' | 'memo' | 'tagOrMemo';

export const adTagMemoInfo: Record<string, TagMemoVariant> = {
  XRP: 'tag',
  ATOM: 'memo',
  TON: 'memo',
  XLM: 'tagOrMemo',
};

export const adTranslationKeys: Record<TagMemoVariant, { label: string; placeholder: string; copy: string, copied: string }> = {
  tag: {
    label: 'modals.deposit-modal.xrp-tag',
    placeholder: 'modals.deposit-modal.tag-placeholder',
    copy: 'modals.deposit-modal.copy-tag',
    copied: 'shared.toasts.tag-copied'
  },
  memo: {
    label: 'modals.deposit-modal.memo',
    placeholder: 'modals.deposit-modal.memo-placeholder',
    copy: 'modals.deposit-modal.copy-memo',
    copied: 'shared.toasts.memo-copied'
  },
  tagOrMemo: {
    label: 'modals.deposit-modal.tag-or-memo',
    placeholder: 'modals.deposit-modal.memo-or-tag-placeholder',
    copy: 'modals.deposit-modal.copy-tag-or-memo',
    copied: 'shared.toasts.tag-or-memo-copied'
  }
};


export const getTagMemoType = (ticker: string): TagMemoVariant => {
    return adTagMemoInfo[ticker] ?? null;
};

export const getTranslation = (key: 'label' | 'placeholder' | 'copy' | 'copied', binance_ticker: string): string => {
    const type = getTagMemoType(binance_ticker);
    return adTranslationKeys[type]?.[key] || '';
};
